import { GridFiltersController } from "@repo/baseCloud";
import { useQuery } from "@tanstack/react-query";

import type { PositionViewModel } from "../../models/location";

import { QUERY_KEYS } from "../../api/queries";

export function useExtractStateCode() {
	const statesQuery = useQuery({
		queryKey: [QUERY_KEYS.Maps.AllStates],
		queryFn: () => GridFiltersController.getAllStates(),
	});

	const stateCodes = new Map<string, number>(statesQuery.data?.map((s) => [s.code.toUpperCase(), s.id]) ?? []);

	return (address: string) => {
		const words: string[] = address.toUpperCase().split(" ");

		for (const word of words) {
			if (stateCodes.has(word)) {
				return stateCodes.get(word);
			}
		}

		return -1;
	};
}

export function useExtractStateCodesFromLeads() {
	const extractStateCode = useExtractStateCode();

	return (leads: PositionViewModel[]) => {
		const addresses = new Set<string>(leads.map((l) => l.address).filter(Boolean));

		return Array.from(addresses).map((address) => extractStateCode(address));
	};
}
